import { HTMLAttributes } from 'react';

export interface Props extends HTMLAttributes<HTMLDivElement> {
    group: string;
    label: string;
}

export const GroupLabel = ({ group, label, ...rest }: Props) => {
    return (
        <div className='text-semantic-fg-muted flex gap-1 text-sm' {...rest}>
            <span className='text-semantic-fg-base font-bold'>{group}</span> {label}
        </div>
    );
};
